import React, { Component} from 'react'
import { connect} from 'react-redux'
import { bindActionCreators} from 'redux'
import { Card} from 'antd'
import CScroll from '@/components/CScroll'
import { setReload, setWindowInfo} from "@/redux/common/action";
import './index.scss'

class MainContent extends Component{

  constructor(props) {
    super(props);
    this.reload = this.reload.bind(this);
    this.listenWindowInfo = this.listenWindowInfo.bind(this);
  }


  // static getDerivedStateFromProps(){
  //
  // }

  reload(){
    this.props.setReload(true);
  }

  // 监听window高宽变化
  listenWindowInfo(){
    let self = this;
    window.addEventListener('resize', function (e) {
      let height = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight;
      let width = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth;
      let mainContentHeight = document.getElementById('mainContent').offsetHeight;
      let mainContentWidth = document.getElementById('mainContent').offsetWidth;
      let value = {
        ...self.props.windowInfo,
        screenHeight: height,
        screenWidth: width,
        mainContentHeight,
        mainContentWidth};
      self.props.setWindowInfo && self.props.setWindowInfo(value);
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.listenWindowInfo();
  }

  componentDidUpdate(){

  }

  render(){
    return (
      <div className='main-content' id='mainContent'>
        <CScroll>
          <div className='main-content-scroll'>
            <div className='main-content-body'>
              <div>
                {this.props.children}
              </div>
            </div>
          </div>
        </CScroll>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    windowInfo: state.windowInfo,
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
